import React from "react";
import { ReactSVG } from "react-svg";
import { useModals, ContactSocial } from "@gw/component-library";
import { useEnvContext } from "@gw/env-context";
import { imgs } from "@gw/theming";
import { ContactStyled } from "./ContactStyled";
import ModalContact from "./ModalContact";
var Contact = function (_a) {
    var id = _a.id, city = _a.city, state = _a.state, website_url = _a.website_url, contact_email = _a.contact_email, twitter = _a.twitter, instagram = _a.instagram, facebook = _a.facebook, size = _a.size;
    var imgsFolder = useEnvContext().imgsFolder;
    var _b = useModals(), openModal = _b.openModal, closeModal = _b.closeModal;
    var handleModal = function () {
        var modalId = "contact-modal-" + id;
        openModal(modalId, "Contact Farm", React.createElement(ModalContact, { modalId: modalId, farmerId: id, closeModal: closeModal }));
    };
    return (React.createElement(ContactStyled, null,
        contact_email && (React.createElement("button", { className: "contact-message gtm-contact-open", onClick: function () { return handleModal(); } },
            React.createElement(ReactSVG, { className: "message-icon", src: imgsFolder + "/" + imgs.icons.iconEnvelope }),
            "Message Farmer")),
        city && state && (React.createElement("div", { className: "contact-item" },
            React.createElement(ReactSVG, { className: "contact-icon", src: imgsFolder + "/" + imgs.icons.iconPlaceGreen }),
            city,
            ", ",
            state,
            React.createElement("div", { className: "divider" }, "|"), size + " acres")),
        React.createElement(ContactSocial, { className: "contact-social", twitter: twitter, instagram: instagram, facebook: facebook, web: website_url })));
};
export default Contact;
//# sourceMappingURL=Contact.js.map